import i18n from "components/i18n/i18n";
import { I18nMessageDefinition, isI18nMessageDefinition} from "components/i18n/I18nMessage";
import "datatables.net";
import { Table } from "../table";
import { ColumnDefinition } from "./ColumnDefinitions";
import { TableColumn } from "./ColumnDefinitions";

export class TextColumn implements DataTables.ColumnDefsSettings, TableColumn {
    public className = "c-datatable__text-column-cell";
    public targets: number;
    public property: string;
    public name: string;
    private table: Table;
    public definition: TextColumnDefinition;
    public orderable = true;

    constructor(column: number, definition: TextColumnDefinition, table: Table) {
        this.table = table;
        this.targets = column;
        this.property = definition.property;
        this.name = this.property;
        this.definition = definition;
        this.orderable = definition.orderable;
    }

    public render = (d: string | I18nMessageDefinition, type: string, row: any) => {
        if (this.definition.customProperty) {
            d = this.table.getValueForFieldInRow(this.definition.property, row);
        }
        // Order, search and type get the original data
        if (type !== "display") {
            return d;
        }

        let m: string;
        if (isI18nMessageDefinition(d) || this.definition.translate) {
            m = this.translateMessage(d);
        } else {
            m = d;
        }
        if (this.definition.tooltipProperty != null && this.definition.tooltipProperty !== "") {
            const text = m ?? "‎&lrm;";
            const tt = this.table.getValueForFieldInRow(this.definition.tooltipProperty, row);
            let ttText;
            if (tt == null) {
                ttText = "";
            } else if (this.definition.translateTooltip) {
                ttText = i18n.t(tt);
            } else {
                ttText = tt;
            }
            return '<div title="' + ttText + '">' + text + "</div>";
        } else if (m != null && this.definition.ellipsis != null && m.length > this.definition.ellipsis) {
            let shortened = m.substr(0, this.definition.ellipsis - 1);
            shortened = TextColumn.esc(shortened);
            return '<span class="ellipsis" title="' + TextColumn.esc(m) + '">' + shortened + "&#8230;</span>";
        } else {
            return m;
        }
    }

    private translateMessage(message: string | I18nMessageDefinition): string {
        if (this.definition.translate) {
            return i18n.t(message);
        } else {
            return message as string;
        }
    }

    private static esc(t: string) {
        return t
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }
}

export interface TextColumnDefinition extends ColumnDefinition {
    ellipsis?: number;
    tooltipProperty?: string;
    translateTooltip?: boolean;
    translate?: boolean;
    orderable?: boolean;
    /**
     * For component columns that have a different property for the non editable column
     */
    customProperty?: boolean;
}
